const yue_Hant_HK = {
  restartInterviewButton: "重新開始",
  restartInterviewConfirmTitle: "重新開始訪談？",
  restartInterviewConfirmDescription: "會開啟一次新嘅訪談，唔會接住而家嘅進度繼續。已有記錄會保留。",
  restartInterviewCancel: "取消",
  restartInterviewFailed: "未能重新開始訪談，請稍後再試",
  restartInterviewLimitReached: "訪談名額已滿，無法重新開始。",
  restartInterviewClosed: "訪談已經關閉，唔可以重新開始。",
  restartInterviewCutoff: "訪談已經過咗截止時間，唔可以重新開始。",
  interviewLoading: "正在載入訪談…",
  interviewLinkInvalid: "訪談連結無效",
  interviewLoadFailed: "載入訪談失敗，請稍後再試",
  interviewRetry: "重試",
  saveInfoFailed: '未能儲存資料，請再試一次',
  loadLatestInterviewFailed: '未能載入最新訪談記錄，請稍後再試',
  interviewProgressSaved: '訪談進度唔會流失',
  previousStimulus: '上一個概念',
  nextStimulus: '下一個概念',
  expandStimulus: '放大概念',
  closeStimulusPreview: '關閉概念預覽',
  stimulusPreview: '概念預覽',
  imageTooLarge: '圖片大小唔可以超過 10 MB',
  imageFormatJpegPngOnly: '只支援 PNG、JPEG 同 JPG 格式嘅圖片',
  imageFilesOnly: '只可以上載圖片檔案',
  imageUploadFailed: '未能上載圖片，請再試一次',
  finalUploadFailed: '未能上載檔案，請再試一次',
  Welcome: '歡迎嚟到訪談',
  StartInterview: '開始訪談',
  Submit: '提交',
  Stoprecording: '停止回覆',
  Aiinterviewer: '訪談人',
  AiModeratedInterview: 'AI主持訪談',
  TalkToAva: '同 Ava 傾偈',
  microphoneAccessTitle: '允許使用咪高峰',
  microphoneAccessDescription: 'Ava 需要使用你嘅咪高峰，方便進行自然嘅語音對話。',
  microphoneAllow: '允許使用咪高峰',
  microphoneNotNow: '暫不',
  microphoneConnectedTitle: '咪高峰已連接',
  microphoneConnectedDescription: '一切就緒，Ava 已準備好聆聽。',
  microphoneDeniedTitle: '需要咪高峰權限',
  microphoneDeniedDescription: '請喺瀏覽器設定中允許咪高峰存取，然後重試。',
  microphoneTryAgain: '重試',
  VoiceAnswer: '語音回覆',
  TextAnswer: '文字回覆',
  StudyMainTitle: '正式訪談之前，我哋會先做一次篩選',
  StudyMainTip: '唔好意思，你唔係今次訪談嘅目標群體，未能參與今次訪談',
  // ThankYou: '多謝',
  //
  TitleTop: '快啲嚟傾下啦',
  HeardVoice: '你嘅聲音值得被聽見、被鼓勵！',
  Sophie: '同 Ava 做一次簡短訪談啦',
  Sponsored: 'Sponsored by Santa Clause🎅',
  Chikkens: '開始一段簡短聊天並獲得專屬',
  Dollars: '屬於你嘅 CHIMOJI 獎勵！',
  // Progress: 'the progress of this chat',
  Congrats: '恭喜完成！',
  ThankYou: '多謝你分享見解',
  Refresh: '刷新本頁唔會遺失聊天進度',
  Carousel: '因應網絡狀況，可能會有輕微延遲',
  CheckOut: '你都想建立呢類訪談？睇下 ',
  Rewarded: '如果你想獲得獎勵，訪談人需要了解你嘅資料 ',
  InterviewerReward: '呢個係訪談人俾你嘅獎勵 ',
  Register: '登入/註冊成為',
  Insighteer: 'INSIGHTEER',
  Reward: '以獲取專屬獎勵',
  CreatePassword: '建立密碼完成註冊',
  Becoming: '加入我哋啦！',
  Password: '請輸入你嘅密碼！',
  ChooseTopic: '揀一個你感興趣嘅話題',
  Identity: '你係...',
  Awesome: 'Awesome!',
  Rocks: 'ROCKS',
  Followus: '關注我哋',
  Unique: '呢個獨一無二、專屬於你嘅 CHIMOJI 會連同今次訪談一齊記錄喺區塊鏈上',
  Next: '下一步',
  ViewRewards: '查看獎勵',
  endMeg1: '請喺呢度留下你嘅電郵，方便我哋傳送語音回放俾你',
  endMeg2: '請喺呢度留下你嘅資料，以獲取今次訪談建立者嘅獎勵',
  endMeg3: '請喺呢度留下你嘅資料俾今次訪談',
  endMsg5: '請喺呢度留下你嘅資料以獲取',
  endMsg6: '你嘅 MBTI 測試結果',
  Done: '提交',
  Done1: '完成',
  GetIncentives: '獲取獎勵',
  GetStartedFreeNow: '立即免費開始',
  UniqueChimojiNFT: '獨特嘅 Chimoji NFT',
  endMsg4: '想建立自己嘅訪談？',
  ResumeInterview: '點擊繼續訪談',
  interviewPausedTitle: '訪談已暫停',
  interviewPausedDescription: '你的訪談進度已儲存，準備好後可以隨時繼續。',
  resumeInterviewButton: '繼續訪談',
  pauseInterview: '暫停',
  pauseInterviewConfirmTitle: '暫停訪談？',
  pauseInterviewConfirmContent: '目前進度會保留，之後可以繼續訪談。',
  pauseInterviewConfirmOk: '暫停',
  pauseInterviewConfirmCancel: '繼續訪談',
  poorConnection: '連線不佳',
  connectionReconnectingTitle: '正在重新連線…',
  connectionReconnectingDescription: '請保持呢個頁面開啟，Ava 正在恢復連線。',
  connectionReconnectedTitle: '已重新連線',
  connectionReconnectedDescription: '網絡已恢復，正在繼續訪談。',
  connectionDisconnectedTitle: '連線已中斷',
  connectionDisconnectedDescription: '你嘅訪談進度已儲存。',
  refresh: '刷新頁面唔會遺失進度',
  voiceSnapshot: '語音快照',
  fromInterview: '嚟自 AI Ava 對我嘅訪談',
  findMore: '喺 chikka.ai 了解更多',
  msg1: '同 AVA 傾偈，5 分鐘內測試你嘅 MBTI',
  speaking: '你正在講嘢...',
  avaSpeaking: 'AVA 正在講嘢...',
  avaListening: 'AVA 正在聽...',
  stimuliConversationWithAva: '你正同 Ava 進行對話',
  stimuliReviewConcepts: '請仔細查看下面嘅概念內容，並回答 Ava 嘅問題。',
  stimuliSwipeInstruction: '左右滑動以查看全部概念內容。',
  stimuliFullscreenInstruction: '雙擊圖片可以全螢幕查看。',
  finalUploadTitleFallback: '上傳文件',
  finalUploadInstructionFallback: '結束訪談前請先上傳文件',
  finalUploadTap: '點擊上傳',
  finalUploadHelp: '你嘅文件可以幫助我哋更好理解你嘅體驗。',
  finalUploadLimit: '最多 10 個文件',
  finalUploadSubmit: '提交',
  finalUploadSkip: '跳過',
  finalUploadWait: '請等待所有文件上傳完成',
}
export default yue_Hant_HK
